var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "loadingBlock",
      staticClass: "loading-block",
      staticStyle: { position: "relative" }
    },
    [
      _vm.value === null
        ? [
            _vm.type === "string"
              ? _c("span", [_vm._v("-")])
              : _vm.type === "money"
              ? _c("span", [_vm._v("￥ -")])
              : _vm._e()
          ]
        : [_vm._t("default")]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4eb52c61", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eb52c61","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoadingBlock.vue
// module id = null
// module chunks = 